import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as CentralBankPaymentListService from '../../../services/api/payment_central_bank';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from '../gl_modal_reducer/types';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';
import { StringNullableChain } from 'lodash';

interface SetCentralBankPaymentInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  account: string | null;
  statusCode: string | null;
  dateFrom: string | null;
  dateTo: string | null;
}

class SetCentralBankPayments implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_CENTRAL_BANK_PAYMENT_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_CENTRAL_BANK_PAYMENT_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_CENTRAL_BANK_PAYMENT_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: SetCentralBankPaymentInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await CentralBankPaymentListService.fetchCentralBankPaymentList(
            payload
          );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('SetPayments Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class SetCentralBankPaymentStatusCodesList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_CENTRAL_BANK_PAYMENT_STATUS_CODES_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_CENTRAL_BANK_PAYMENT_STATUS_CODES_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_CENTRAL_BANK_PAYMENT_STATUS_CODES_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await CentralBankPaymentListService.fetchCentralBankPaymentStatusCodes();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('SetPayments Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class SetCentralBankPaymentAccountsList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_CENTRAL_BANK_PAYMENT_ACCOUNTS_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_CENTRAL_BANK_PAYMENT_ACCOUNTS_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_CENTRAL_BANK_PAYMENT_ACCOUNTS_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await CentralBankPaymentListService.fetchCentralBankPaymentAccounts();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        dispatch(this.onFailed());
      }
    };
  }
}

interface IUpdateCentralBankPaymentStatusInput {
  id: number;
  statusCode: number;
  onSuccess?: () => void;
}
class UpdateCentralBankPaymentStatus implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.UPDATE_CENTRAL_BANK_PAYMENT_STATUS,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.UPDATE_CENTRAL_BANK_PAYMENT_STATUS,
      status: StateStatus.Success,
      data: null,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.UPDATE_CENTRAL_BANK_PAYMENT_STATUS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IUpdateCentralBankPaymentStatusInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await CentralBankPaymentListService.updateCentralBankPaymentStatus(
          payload
        );
        if (payload.onSuccess) payload.onSuccess();
        dispatch(this.onSuccess());
      } catch (error: any) {
        // console.log('UpdatePaymentInfoReference Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}
interface IFetchCentralBankPaymentsInput {
  onSuccess?: () => void;
}
class FetchCentralBankPayments implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.FETCH_CENTRAL_BANK_PAYMENTS,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.FETCH_CENTRAL_BANK_PAYMENTS,
      status: StateStatus.Success,
      data: null,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.FETCH_CENTRAL_BANK_PAYMENTS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IFetchCentralBankPaymentsInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await CentralBankPaymentListService.fetchCentralBankPayments();
        if (payload.onSuccess) payload.onSuccess();
        dispatch(this.onSuccess());
      } catch (error: any) {
        // console.log('UpdatePaymentInfoReference Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IMatchCentralBankPaymentsInput {
  onSuccess?: () => void;
}
class MatchCentralBankPayments implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.MATCH_CENTRAL_BANK_PAYMENTS,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.MATCH_CENTRAL_BANK_PAYMENTS,
      status: StateStatus.Success,
      data: null,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.MATCH_CENTRAL_BANK_PAYMENTS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IMatchCentralBankPaymentsInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await CentralBankPaymentListService.matchPcbPayments();
        if (payload.onSuccess) payload.onSuccess();
        dispatch(this.onSuccess());
      } catch (error: any) {
        // console.log('UpdatePaymentInfoReference Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  setCentralBankPaymentsAction: (payload: SetCentralBankPaymentInput) =>
    new SetCentralBankPayments().action(payload),
  SetCentralBankPaymentStatusCodesAction: () =>
    new SetCentralBankPaymentStatusCodesList().action(),
  SetCentralBankPaymentAccountsAction: () =>
    new SetCentralBankPaymentAccountsList().action(),
  updateCentralBankPaymentStatus: (
    payload: IUpdateCentralBankPaymentStatusInput
  ) => new UpdateCentralBankPaymentStatus().action(payload),
  fetchCentralBankPayments: (payload: IFetchCentralBankPaymentsInput) =>
    new FetchCentralBankPayments().action(payload),
  matchCentralBankPayments: (payload: IMatchCentralBankPaymentsInput) =>
    new MatchCentralBankPayments().action(payload),
};
